import { render } from "./VariationComponent.vue?vue&type=template&id=342bc09e"
import script from "./VariationComponent.vue?vue&type=script&lang=js"
export * from "./VariationComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/components/VariationComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "342bc09e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('342bc09e', __exports__)) {
    api.reload('342bc09e', __exports__)
  }
  
  module.hot.accept("./VariationComponent.vue?vue&type=template&id=342bc09e", () => {
    api.rerender('342bc09e', render)
  })

}


export default __exports__